module.exports = __webpack_public_path__ + "static/7-e38c3055c1df59ac6012c767caae61da.png";